module.exports = __webpack_public_path__ + "img/more.c51beca0.png";